import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, Select } from 'antd';
import {EditOutlined} from '@ant-design/icons';
import axios from 'axios';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
const { Option } = Select;

const ModelUpdateForm = ({ visible, onCreate, onCancel, record }) => {
  
  let model = record
  const [form] = Form.useForm();
  const [modelID]=useState(model.ModelID)
  const [makeID]=useState(model.MakeID)
  const [make, setMake]=useState();
  const [modelName]=useState(model.Model)

  useEffect(()=>{

    //${FetchVariable.Heroku}
    let getMake = `${FetchVariable.Heroku}/make/`;
      axios.get(getMake)
        .then((res)=>{
          let data = res.data
          setMake(data)
        })  
    },[])

  return (
    <Modal
      visible={visible}
      title="Update Model"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="MakeUpdate"
        initialValues={{
            ModelID:modelID,
            MakeID:makeID,
            Model:modelName
        }}
      >
       <Form.Item
          name="ModelID"
          label="Model ID"
        >
            <Input disabled/>
        </Form.Item>   
        <Form.Item name='MakeID' label="Make">
          <Select>
            {make?.map(Make=><Option value={Make.MakeID} key={Make.MakeID}>{Make.Make}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item
          name="Model"
          label="Model"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ModelUpdate = (props) => {
  
  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateModel(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
  
      </Button>
      <ModelUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default ModelUpdate